import React from 'react'
import { Link } from 'react-router-dom'

const Footer = (props) => (
  <footer className="mw9 ph3 center">
    <div className="bt b--light-gray pt4 pb3 cf">
      <h4 className="fw6 mv2">Polaris Investing © 2017</h4>
      <ul className="fl ma0 pa0">
        <li className="dib-ns list ma0 pa0 mr3">
          <Link className="link blue" to="/terms">Terms</Link>
        </li>
        <li className="dib-ns list ma0 pa0 mr3">
          <Link className="link blue" to="/privacy">Privacy</Link>
        </li>
        <li className="dib-ns list ma0 pa0 mr3">
          <a className="link blue" href="mailto:support@polarisinvesting.com">Contact Support</a>
        </li>
      </ul>

      <ul className="list ma0 pa0 fr">
        <li className="dib ma2">
          <a href="https://medium.com/polaris-investing" className="link gray">
            <i className="socicon-medium"></i>
          </a>
        </li>
        <li className="dib ma2">
          <a href="http://twitter.com/getpolaris" className="link gray">
            <i className="socicon-twitter"></i>
          </a>
        </li>
        <li className="dib ma2">
          <a href="https://www.facebook.com/polarisinvesting" className="link gray">
            <i className="socicon-facebook"></i>
          </a>
        </li>
      </ul>
    </div>

    <div className="pb4">
      <p className="f6 measure-wide silver">Information is provided 'as is' and solely for informational purposes, not for trading purposes or advice.</p>
      <p className="f6 measure-wide silver">Polarisinvesting.com makes information available on this web site Polarisinvesting.com (the "Site") subject to the terms and conditions. Please read the terms and conditions carefully. Your use of this web site signifies you agree to these terms and conditions otherwise you should not use the Site.</p>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js